module.exports = __webpack_public_path__ + "media/images/ofn-logo-acdb60463f12c282f72e1ce490404b10.png";